import AdminReducer from "./admin";
import ApprovalReducer from "./approval";
import AssignmentReducer from "./assignment";
import MenuReducer from "./menu";
import PermissionReducer from "./permission";
import RoleReducer from "./role";
import RouteReducer from "./route";

export default {
  admin: AdminReducer,
  approval: ApprovalReducer,
  assignment: AssignmentReducer,
  menu: MenuReducer,
  permission: PermissionReducer,
  role: RoleReducer,
  route: RouteReducer,
};
